<template>
  <router-view />
</template>

<script setup lang="ts">
// 基础样式（字体/背景/主色令牌）在 src/styles/theme.css，由 main.ts 统一引入。
// 这里不再放全局样式，避免和 theme.css 抢着定义 body 与 #app。
</script>
